/**
 * Chatbot sanitization helpers
 */


const CONTROL_CHAR_REGEX = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;

/**
 * Sanitize plain-text user input before sending to backend.
 * Keeps intent while removing potentially dangerous or noisy input artifacts.
 */
export const sanitizeChatInput = (input = ''): string => {
  const noControls = input.replace(CONTROL_CHAR_REGEX, '');

  return noControls;
};


/**
 * Mask personally identifying values but keep minimal utility for context.
 */
export const maskSensitiveValue = (value = ''): string => {
  const trimmed = value.trim();
  if (!trimmed) return '';

  if (trimmed.length <= 4) {
    return '*'.repeat(trimmed.length);
  }

  return `${trimmed.slice(0, 2)}***${trimmed.slice(-2)}`;
};
